"use client";

import { MantineProvider } from "@mantine/core";
import { Notifications } from "@mantine/notifications";
import { resolver, theme } from "@/theme";
import "@fontsource/noto-sans/400.css";
import "@fontsource/noto-serif/400.css";
import "@fontsource/noto-sans-mono/400.css";
import "@mantine/core/styles.css";
import "@mantine/notifications/styles.css";

export function Provider({ children }: { children: React.ReactNode }) {
  return (
    <MantineProvider theme={theme} defaultColorScheme="light" cssVariablesResolver={resolver}>
      {children}
      <Notifications position="top-right" zIndex={1200} />
    </MantineProvider>
  );
}
